'use strict';

angular.module('TurneroApp').component('coAgendaFinalizar', {
    bindings: {
        ctrlPadre: '='
    }, controller: [
        '$rootScope',
function ($rootScope) {
            var ctrl = this;
            ctrl.consultaAgendas = function () {
                ctrl.ctrlPadre.consultaAgendas(true);
            }


        }
    ],
    template: require('./agenda_Finalizar.html')
});



// WEBPACK FOOTER //
// ./app/components/agenda/agenda_FinalizarComponent.js